/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if(boostSDAppConfig?.searchSettings) {
  boostSDAppConfig.searchSettings.suggestionMobileStyle = 'style2';
}

const getWindowLocation = () => {
	// Escape window.location.href
	var href = window.location.href;
	var escapedHref = href.replace(/%3C/g, '&lt;').replace(/%3E/g, '&gt;');

	// Rebuild window.location.href
	var rebuildHrefArr = [];
	for (var i = 0; i < escapedHref.length; i++) {
		rebuildHrefArr.push(escapedHref.charAt(i));
	}
	var rebuildHref = rebuildHrefArr.join('').split('&lt;').join('%3C').split('&gt;').join('%3E');

	// Rebuild window.location.search
	var rebuildSearch = "";
	var hrefWithoutHash = rebuildHref.replace(/#.*$/, '');
    
	if (hrefWithoutHash.split('?').length > 1) {
		rebuildSearch = hrefWithoutHash.split('?')[1];
		if (rebuildSearch.length > 0) {
			rebuildSearch = '?' + rebuildSearch;
		}
	}

	return {
		pathname: window.location.pathname,
		href: rebuildHref,
		search: rebuildSearch
	}
}

const isSearchPage = () => {
	// An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/search?xxx
	// Google cache URL
	if (getWindowLocation().href.includes('webcache.googleusercontent.com')) {
		return getWindowLocation().search.indexOf('search?') > -1;

		// Normal URL
	} else {
		return window.location.pathname.indexOf('/search') > -1;
	}
};

const customize = {
   updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add extra information',
         enabled: true,
         apply: () => ({
           
            afterRender(element) {
              let hasUpdated = false;
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                  if (productItem) {
                    let searchTerm = "";
                      let variant = ""
                    
                    if (isSearchPage() ) {
                          
                      searchTerm = boostSDAppConfig.generalSettings.search_term.toLowerCase();
                      variant = productData.variants.find((item) => item.sku.toLowerCase().indexOf(searchTerm) > -1)
                      if (variant) {
                        let href = productItem?.querySelector('.boost-sd__product-link').getAttribute('href');
                        // href += '?variant=' + variant.id;                    
                        // let length = productItem?.querySelectorAll('.boost-sd__product-link').length;
                        // console.log(productItem?.querySelector('.boost-sd__product-item > .boost-sd__product-link'))
                        // for (let index = 0 ; index < length; index++) {                   
                        //     productItem?.querySelectorAll('.boost-sd__product-link')[index].setAttribute('href', hrefVariant);
                        // }

                        let firstLink = productItem.querySelector('.boost-sd__product-item-grid-view-layout-image > .boost-sd__product-link');
                        let secondLink = productItem.querySelector('.boost-sd__product-item > .boost-sd__product-link');
                        if(firstLink && secondLink ){       
                          firstLink.href = `/products/${productData.handle}/?variant=${variant.id}`
                          secondLink.href = `/products/${productData.handle}/?variant=/${variant.id}`                    
                        }   
                      }
                    }

                    let secondaryTitle = productData.metafields.find(
                      (item) => item.key === 'secondarytitle'
                    );
                    let sdTitleWrapper = document.createElement('div');
                    sdTitleWrapper.classList.add('boost-sd__product-second-title');
                    let productPrice = productItem.querySelector('.boost-sd__product-price');
                    if (!productItem?.querySelector('.boost-sd__product-second-title')) {
                      if (secondaryTitle) {
                        sdTitleWrapper.innerHTML = 'Description: ' + secondaryTitle.value;                        
                      }
                      productPrice.parentNode.insertBefore(sdTitleWrapper, productPrice);
                    }

                    let productSKU = variant ? variant.sku : productData.skus[0];
                    let productSKUHtml = document.createElement('div');
                    productSKUHtml.classList.add('boost-sd__product-sku');
                    productSKUHtml.innerHTML = 'Sku: ' + productSKU;
                    if (!productItem?.querySelector('.boost-sd__product-sku')) {
                      productPrice.parentNode.insertBefore(productSKUHtml, productPrice);
                    }
                    
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.error(e);
               }
            }
         }),
      });
   },
  updateFilterTreeElement: (componentRegistry) => {
    componentRegistry.useComponentPlugin('FilterTree', {
         name: 'Add extra information',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                 let filterTree = element.getRootElm();
                 let collectionPromo = document.querySelector('.collection-promo-banner');
                 if(!isSearchPage()){
                    filterTree.appendChild(collectionPromo);
                 }
                
               } catch (e) {
                  console.error(e);
               }
            }
         }),
      });
  },
  updateProductItemISW: (componentRegistry) => {
      componentRegistry.useComponentPlugin('SearchProductItem', {
         name: 'Customize product item ISW',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('.boost-sd__suggestion-queries-item--product[data-id="' + productId + '"]');
                  if (productItem) {
                     /* use pure js here */
                    if (productItem?.querySelector('.boost-sd__suggestion-queries-item-sku')) {
                      let productPrice = productItem?.querySelector('.boost-sd__suggestion-queries-item-price');
                      let productSkus = productItem?.querySelector('.boost-sd__suggestion-queries-item-sku');
                      productPrice.parentNode.insertBefore(productSkus, productPrice);
                    }
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.error(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid, customize.updateFilterTreeElement, customize.updateProductItemISW]);

// const customize2 = {
//   moveHeaderDescription: (componentRegistry) => {
//     componentRegistry.useComponentPlugin("ProductItem", {
//       name: "Move Collection Description Below Product List",
//       apply: () => {
//          let hasUpdated = false; // Prevent rendering twice
//          return {
//             afterRender(element) {
//                try {
//                  let productData = element.getParams().props.product;
//                   let productId = productData.id;
//                   if (productData?.split_product) {
//                      productId = productData.variant_id;
//                   }
//                   let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                 
//                        if (isSearchPage() && productItem) {
                          
//                       let searchTerm = boostSDAppConfig.generalSettings.search_term.toLowerCase();
//                       let variant = productData.variants.find((item) => item.sku.toLowerCase().indexOf(searchTerm) > -1)
                     
//                       if (variant) {
                         
//                         let href = productItem?.querySelector('.boost-sd__product-link').getAttribute('href');
//                         // href += '?variant=' + variant.id;
//                         console.log(href + '?variant=' + variant.id)
//                           let hrefVariant = href + '?variant=' + variant.id
                       
                        
//                          // console.log(hrefVariant)
//                         // let length = productItem?.querySelectorAll('.boost-sd__product-link').length;
//                         // console.log(productItem?.querySelector('.boost-sd__product-item > .boost-sd__product-link'))
//                         // for (let index = 0 ; index < length; index++) {                   
//                         //     productItem?.querySelectorAll('.boost-sd__product-link')[index].setAttribute('href', hrefVariant);
//                         // }

//                         let firstLink = productItem.querySelector('.boost-sd__product-item-grid-view-layout-image > .boost-sd__product-link');
//                         let secondLink = productItem.querySelector('.boost-sd__product-item > .boost-sd__product-link');
              
//                         if(firstLink && secondLink  && !hasUpdated){
                      
//                           firstLink.setAttribute('href', hrefVariant);
//                           secondLink.setAttribute('href', hrefVariant);
//                             hasUpdated = true;
//                         }
                        
//                       }
//                     }
             
//                   }
//                 catch (err) {
//                   console.warn(err);
//                }
//             }
//          }
//       }
//    })
//   }  
// }

// window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize2.moveHeaderDescription]);